// extracted by mini-css-extract-plugin
export default {"logoImage":"header_logo_image-module__logoImage--OcNvH"};